import { render, staticRenderFns } from "./treasureCalendarEvent.vue?vue&type=template&id=a5e845aa&scoped=true&"
import script from "./treasureCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./treasureCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./treasureCalendarEvent.vue?vue&type=style&index=0&id=a5e845aa&scoped=true&lang=css&"
import style1 from "./treasureCalendarEvent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e845aa",
  null
  
)

export default component.exports